import React from 'react';
import { LocationTemplate } from "./location";

export function Template({
  template,
  conf,
  namespace,
  user,
  location,
}) {
  switch (namespace) {
    case 'scl':
    case 'location':
    case 'village':
    case 'scp':
    case 'event':
    case 'lir':
    case 'corrective-actions':
    case 'incidents':
    case 'kyc':
    case 'stakeholder':
      return <LocationTemplate namespace={namespace} location={location} conf={conf} template={template} user={user} />;
    default:
      return null;

  }
}
